import { Alert } from "@mui/material";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";

export const ViewOnlyNotice = () => (
  <Alert
    severity="info"
    icon={<VisibilityOutlinedIcon />}
    sx={{ my: 1 }}
    data-testid="view-only-notice">
    View only — sections can be expanded, but values cannot be edited.
  </Alert>
);
